import { createReducer } from "@reduxjs/toolkit";
import {
    defaultDistanceUnits,
    MapState,
    defaultCurbLinks,
    defaultHighlightedMapLayersData
} from "../actions/Map/types";
import { defaultGeoserverData } from "../interfaces/Geoserver";
import {
    curbLinksReceived,
    getCurbLinks,
    isPointerEventsEnabled,
    setHighlightedMapLayersData,
    setLatLng,
    setMapObject,
    setMarkers,
    storeGeoserverData,
    toggleDistanceTool,
    toggleMap
} from "actions";

const initialState: MapState = {
    center: [],
    zoomControl: false,
    mapBoxMaxZoom: 22,
    mapBoxMinZoom: 0,
    attributionControl: false,
    mapMarkers: {},
    curbLinks: defaultCurbLinks,
    mapObject: null,
    isCurbLinksReceived: false,
    isSatelliteMapSelected: false,
    isDistanceToolEnabled: false,
    distanceUnits: defaultDistanceUnits,
    geoserverData: defaultGeoserverData,
    isPointerEventsEnabled: true,
    highlightedMapLayersData: defaultHighlightedMapLayersData
};

const map = createReducer(initialState, (builder) => {
    builder
        .addCase(toggleDistanceTool, (state, action) => {
            state.distanceUnits = action.payload.units;
            state.isDistanceToolEnabled = action.payload.toggle;
        })
        .addCase(setLatLng, (state, action) => {
            state.center = action.payload.center;
        })
        .addCase(setMarkers, (state, action) => {
            state.mapMarkers = action.payload.markers;
        })
        .addCase(getCurbLinks, (state) => {
            state.isCurbLinksReceived = false;
        })
        .addCase(curbLinksReceived, (state, action) => {
            state.curbLinks = action.payload.curbLinks;
            state.isCurbLinksReceived = true;
        })
        .addCase(setMapObject, (state, action) => {
            state.mapObject = action.payload.obj;
        })
        .addCase(toggleMap, (state, action) => {
            state.isSatelliteMapSelected = action.payload.mapType;
        })
        .addCase(storeGeoserverData, (state, action) => {
            state.geoserverData = action.payload.data;
        })
        .addCase(isPointerEventsEnabled, (state, action) => {
            state.isPointerEventsEnabled = action.payload.data;
        })
        .addCase(setHighlightedMapLayersData, (state, action) => {
            state.highlightedMapLayersData = action.payload.highlightedMapLayersData;
        })
        .addDefaultCase((state) => state);
});

export default map;
